import React from 'react';
import UserJson from '../../../content/admin/user.json';
import GenericForm from 'rev.sdk.js/Generic/Form';
import RjsfAddressField from '../../Components/RjsfAddressField';
import * as JStorage from '../../JStorage';
import styled from 'styled-components';
import AdminDateWidget from '../../Generators/AdminResource/AdminDateWidget';
import AdminTimestampWidget from '../../Generators/AdminResource/AdminTimestampWidget';
import * as Ant from 'antd';
import * as AppActions from '../../AppActions';

const rjsfProps = {
  widgets: {
    'admin-date-widget': AdminDateWidget,
    'admin-timestamp-widget': AdminTimestampWidget,
    'admin-date-widget': AdminDateWidget,
  },
  fields: {
    'rev-address-field': RjsfAddressField,
  },
};

export default function RevisionDetail(props) {
  const {id, isAdmin, onSuccess} = props;
  const [record, setRecord] = React.useState();
  const [formData, setFormData] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const {schema, uiSchema} = React.useMemo(() => {
    let newProperties = {};
    if (formData && Object.keys(formData.new_data).length > 0) {
      for (let key in formData.new_data) {
        if (UserJson.formSpec.schema.properties[key]) {
          newProperties[key] = {
            ...UserJson.formSpec.schema.properties[key],
            readOnly: true,
          };
        }
      }
    }

    let uiSchema = {
      classNames: 'revision-section',
      ...UserJson.formSpec.uiSchema,
      avatar: {},
    };

    return {
      schema: {
        properties: {
          old_data: {
            title: '修改前資料',
            type: 'object',
            properties: newProperties,
          },
          new_data: {
            title: '修改後資料',
            type: 'object',
            properties: newProperties,
          },
        },
      },
      uiSchema: {
        old_data: uiSchema,
        new_data: uiSchema,
      },
    };
  }, [formData]);

  const getRecord = React.useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        let resp = await JStorage.fetchOneDocument('revision', {
          id,
        });
        if (resp) {
          let formData = {
            old_data: (resp.keys || []).reduce((sum, key, idx) => {
              sum[key] = resp.olds[idx];
              return sum;
            }, {}),
            new_data: (resp.keys || []).reduce((sum, key, idx) => {
              sum[key] = resp.news[idx];
              return sum;
            }, {}),
            created: resp.created,
            status: resp.status || 'pending',
            updated: resp.updated,
          };

          setFormData(formData);
          setRecord(resp);
        }
      } catch (e) {
        console.warn(e);
      }
      setLoading(false);
    }
  }, [id]);

  React.useEffect(() => {
    getRecord();
  }, [getRecord]);

  const submit = async (status) => {
    AppActions.setLoading(true);
    try {
      await AppActions.tdaApproveEditProfile({
        ...record, // record !== formData
        status,
      });
      getRecord();
      onSuccess();
      Ant.message.success('成功更新');
    } catch (e) {
      console.warn(e);
      Ant.message.success('更新失敗');
    }
    AppActions.setLoading(false);
  };

  return loading ? (
    <h2>取得資料中...</h2>
  ) : (
    <Wrapper>
      <div className="date">
        {new Date(formData?.created).toLocaleString('sv').slice(0, 16)}
      </div>

      <h3>資料異動申請</h3>
      <GenericForm
        instance={formData}
        schema={{
          type: 'object',
          properties: {
            status: {
              title: '狀態',
              type: 'string',
              enum: ['pending', 'approved', 'rejected'],
              enumNames: ['審核中', '審核完成', '拒絕修改'],
              readOnly: true,
            },
            updated: {
              title: '審核日期',
              type: 'number',
              readOnly: true,
            },
          },
        }}
        uiSchema={{
          updated: {
            'ui:widget': 'admin-timestamp-widget',
          },
        }}
        rjsfProps={rjsfProps}
        onChange={false}
        onSubmit={false}
        renderCustomSubmitButton={null}
      />

      <div
        style={{
          color: 'var(--primaryColor)',
          fontSize: 12,
          fontWeight: 'bolder',
          marginBottom: 24,
        }}>
        ＊註：審查需7-14工作天才會顯示於基本資料上
      </div>

      <h3>以下欄位申請資料異動</h3>
      <GenericForm
        instance={formData}
        schema={schema}
        uiSchema={uiSchema}
        rjsfProps={rjsfProps}
        onChange={false}
        onSubmit={false}
        renderCustomSubmitButton={null}
      />

      {isAdmin && (
        <Ant.Space style={{width: '100%', justifyContent: 'flex-end'}}>
          <Ant.Button
            type="primary"
            danger
            onClick={() => submit('rejected')}
            disabled={['approved', 'rejected'].includes(record?.status)}>
            拒絕
          </Ant.Button>
          <Ant.Button
            type="primary"
            onClick={() => submit('approved')}
            disabled={['approved', 'rejected'].includes(record?.status)}>
            通過
          </Ant.Button>
        </Ant.Space>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & > h3 {
    margin-bottom: 5px;
  }
  & > .date {
    color: #9e9e9e;
    margin: 10px 0;
  }

  & .revision-section label[for='root-title'] {
    font-weight: 600;
    margin-bottom: 0px;
  }
`;
